import {Form } from 'react-bootstrap'
import React, { useCallback, useEffect, useState } from 'react'
import CustomDatePicker from '../../Forms/CustomDatePicker'
import { getIsoDate } from '../../../utils/getIsoDate'
import { useTranslation } from 'react-i18next'
import { StyledValidationMessage } from '../../Employees/Form/formHelper'
import MandatoryField from '../../MandatoryField/MandatoryField'
import ArticleSelect from '../../Files/Form/ArticleSelect'


const StatisticRFIDs = ({ formData, setFormData, formErrors }) => {
    const { t } = useTranslation()
    const [dateFrom, setDateFrom] = useState(null)
    useEffect(() => {
        setFormData(prev => {
            if (dateFrom) {
                return { ...prev, startDate: getIsoDate(dateFrom, false) }
            }
            delete prev.startDate
            return prev
        })
    }, [setFormData, dateFrom])
    const handleChangeDate = useCallback(setDate => date => {
        setDate(date)
    }, [])

    return (
        <div>
            <Form.Group className="mb-3">
                <Form.Check
                    id="showMissingRFIDs"
                    label={t('reportConfig:showMissingRFIDs')}
                    type="checkbox"
                    name="showMissingRFIDs"
                    onChange={e => setFormData(prev => ({
                        ...prev,
                        showMissingRFIDs: e.target.checked
                    }))}
                    checked={formData.showMissingRFIDs}
                    isInvalid={formErrors && formErrors.showMissingRFIDs}
                />
                <Form.Label>{t('reportConfig:forShipmentsCreatedAtOrAfter')}</Form.Label>
                <CustomDatePicker
                    dateFormat="dd.MM.yyyy"
                    placeholderText={t('date')}
                    onChange={handleChangeDate(setDateFrom)}
                    showYearDropdown
                    selected={dateFrom}
                    isInvalid={formErrors && formErrors.startDate}
                    disabled={!formData.showMissingRFIDs}
                />
                {formErrors && formErrors.startDate && <StyledValidationMessage>{formErrors.startDate}</StyledValidationMessage>}
            </Form.Group>
            <Form.Group className='mb-3'>
                <Form.Label className='d-block ps-1'>
                    {`${t('reportConfig:articleSelection')}`}
                </Form.Label>
                <ArticleSelect
                    name='articleIDs'
                    value={formData.articleIDs}
                    setFormData={setFormData}
                />
            </Form.Group>
            <Form.Group className="mb-3">
                <Form.Label>{t(`reportConfig:emailAddress`)}</Form.Label>
                <Form.Control
                    name="emailAddress"
                    onChange={e => setFormData(prev => ({
                        ...prev,
                        emailAddress: e.target.value
                    }))}
                    value={formData.emailAddress || ''}
                    isInvalid={formErrors && formErrors.emailAddress}
                    autoComplete="email" />
                <Form.Control.Feedback type="invalid">
                    {formErrors && formErrors.emailAddress}
                </Form.Control.Feedback>
            </Form.Group>
            <MandatoryField />
        </div>
    )
}
export default StatisticRFIDs